module.exports = __webpack_public_path__ + "static/img/diplo2.306a754.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/diplo2.jpg
// module id = 546
// module chunks = 2